﻿(function () {
  var WA = "201000059085";

  function msgFor() {
    var ar = (document.documentElement.lang || "").toLowerCase().indexOf("ar") === 0;
    return ar
      ? {
          msg: "السعر غير متاح حاليًا — تواصل معنا لتأكيد التوفر.",
          cartWarn: "تمت إزالة منتجات غير متاحة للشراء من السلة.",
        }
      : {
          msg: "Price currently unavailable — contact us to confirm availability.",
          cartWarn: "Unavailable-to-purchase items were removed from your cart.",
        };
  }

  function blockedIds() {
    return (window.__PETSPOT_BLOCKED_VARIANT_IDS || []).map(String);
  }

  function isBlockedId(id) {
    return blockedIds().indexOf(String(id)) >= 0;
  }

  function currentVariantId() {
    var input =
      document.querySelector('product-form-component input[name="id"]') ||
      document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      document.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function stripLegacyDuplicateWa() {
    // Remove old generic blocked WA anchors; keep universal order CTA only
    document.querySelectorAll("a.petspot-price-unavailable__wa, [data-testid='petspot-blocked-whatsapp'], [data-testid='petspot-request-availability']").forEach(function (el) {
      el.remove();
    });
  }

  function hidePurchaseUI() {
    var vid = currentVariantId();
    var blockedSelected = vid && isBlockedId(vid);
    if (
      !blockedSelected &&
      !document.querySelector(
        '.petspot-price-unavailable,[data-petspot-hide-purchase="true"]'
      )
    )
      return;
    // Hide ATC / accelerated checkout only — keep quantity + universal WA CTA
    document
      .querySelectorAll(
        "button[name=add], .shopify-payment-button, add-to-cart-component, .quick-add, .sticky-add-to-cart"
      )
      .forEach(function (el) {
        el.style.display = "none";
        el.setAttribute("disabled", "disabled");
        el.setAttribute("aria-hidden", "true");
      });
  }

  function deny() {
    var t = msgFor();
    return new Response(
      JSON.stringify({
        status: 422,
        message: t.msg,
        description: t.msg,
        petspot_blocked: true,
      }),
      { status: 422, headers: { "Content-Type": "application/json" } }
    );
  }

  var origFetch = window.fetch.bind(window);
  window.fetch = async function (input, init) {
    init = init || {};
    try {
      var url = typeof input === "string" ? input : (input && input.url) || "";
      if (url.indexOf("/cart/add") >= 0) {
        var ids = [];
        var body = init.body;
        if (typeof body === "string") {
          try {
            var j = JSON.parse(body);
            if (j.id) ids.push(String(j.id));
            (j.items || []).forEach(function (i) {
              ids.push(String(i.id));
            });
          } catch (e) {
            var p = new URLSearchParams(body);
            if (p.get("id")) ids.push(p.get("id"));
          }
        }
        if (ids.some(isBlockedId)) return deny();
      }
    } catch (e) {}
    return origFetch(input, init);
  };

  document.addEventListener(
    "submit",
    function (e) {
      try {
        var form = e.target;
        if (!form || !form.action) return;
        if (String(form.action).indexOf("/cart/add") < 0) return;
        var idInput = form.querySelector("[name=id]");
        if (idInput && isBlockedId(idInput.value)) {
          e.preventDefault();
          e.stopPropagation();
          alert(msgFor().msg);
        }
      } catch (err) {}
    },
    true
  );

  function scrubLe1Text(root) {
    try {
      var t = msgFor();
      var re = /(?:LE|E£|ج\.?\s*م\.?)\s*1(?:[.,]00)?\b|\b1(?:[.,]00)?\s*(?:LE|E£)/i;
      (root || document)
        .querySelectorAll(
          ".price, .price-item, .petspot-product-card__price, product-price, [ref=priceContainer], .cart-item__price"
        )
        .forEach(function (el) {
          if (el.getAttribute("data-petspot-pricing-blocked") === "true") return;
          if (el.querySelector(".petspot-price-unavailable")) return;
          var txt = (el.textContent || "").replace(/\s+/g, " ").trim();
          if (re.test(txt) && txt.length < 40) {
            el.innerHTML =
              '<span class="petspot-price-unavailable__msg">' +
              t.msg +
              "</span>";
            el.setAttribute("data-petspot-pricing-blocked", "true");
          }
        });
    } catch (e) {}
  }

  async function cleanupBlockedCartLines() {
    try {
      var cart = await (await origFetch("/cart.js", { credentials: "same-origin" })).json();
      var updates = {};
      var removed = 0;
      (cart.items || []).forEach(function (item) {
        var vid = String(item.variant_id || item.id);
        var price = Number(item.price || 0);
        var blocked = isBlockedId(vid) || price <= 101;
        if (blocked && Number(item.quantity || 0) > 0) {
          updates[item.key || item.id] = 0;
          removed += 1;
        }
      });
      if (!removed) return 0;
      await origFetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: updates }),
      });
      var banner = document.getElementById("petspot-cart-blocked-warning");
      if (!banner) {
        banner = document.createElement("div");
        banner.id = "petspot-cart-blocked-warning";
        banner.setAttribute("role", "status");
        banner.style.cssText =
          "padding:0.75rem 1rem;margin:0.5rem 0;background:#fff4e5;border:1px solid #f0c36d;border-radius:8px;";
        var host =
          document.querySelector("cart-drawer-component, .cart-drawer, cart-items-component, main") ||
          document.body;
        host.prepend(banner);
      }
      banner.textContent = msgFor().cartWarn;
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      return removed;
    } catch (e) {
      return 0;
    }
  }

  function scrubSoldOutLabels() {
    try {
      var t = msgFor();
      var label = t.msg.split("—")[0].trim() || t.msg;
      document.querySelectorAll("[aria-label*='Sold out'], [aria-label*='sold out']").forEach(function (el) {
        var a = el.getAttribute("aria-label") || "";
        el.setAttribute("aria-label", a.replace(/sold out/gi, label));
      });
      document.querySelectorAll(".badge--sold-out, .color-custom-badge-sold-out, .product-badges .badge").forEach(function (el) {
        var txt = (el.textContent || "").trim();
        if (/sold out/i.test(txt)) {
          el.textContent = label;
          el.classList.add("petspot-badge-price-unavailable");
        }
      });
    } catch (e) {}
  }

  function onVariantChange() {
    stripLegacyDuplicateWa();
    hidePurchaseUI();
    scrubLe1Text(document);
    scrubSoldOutLabels();
  }

  document.addEventListener("DOMContentLoaded", function () {
    stripLegacyDuplicateWa();
    hidePurchaseUI();
    scrubLe1Text(document);
    scrubSoldOutLabels();
    cleanupBlockedCartLines();
  });
  document.addEventListener("variant:change", onVariantChange);
  document.addEventListener("change", function (e) {
    if (
      e.target &&
      e.target.matches &&
      e.target.matches('input[name="id"], variant-picker input, fieldset input[type="radio"]')
    ) {
      onVariantChange();
    }
  });
  setTimeout(function () {
    stripLegacyDuplicateWa();
    hidePurchaseUI();
  }, 500);
  setTimeout(hidePurchaseUI, 1500);
  setTimeout(scrubSoldOutLabels, 600);
  setTimeout(cleanupBlockedCartLines, 800);
  new MutationObserver(function () {
    scrubLe1Text(document);
    scrubSoldOutLabels();
    hidePurchaseUI();
    stripLegacyDuplicateWa();
  }).observe(document.documentElement, { childList: true, subtree: true });

  window.PetSpotPricingGuard = {
    isBlockedId: isBlockedId,
    msgFor: msgFor,
    WA: WA,
    hidePurchaseUI: hidePurchaseUI,
    cleanupBlockedCartLines: cleanupBlockedCartLines,
  };
})();
